import Swiper, {EffectFade, Navigation} from 'swiper';

const historyDateSlider = document.querySelector('.j-history-date-slider');
const historyTextSlider = document.querySelector('.j-history-text-slider');
let slider = {};
let textSlider = {};

const allDates = Array.from(document.querySelectorAll('.j-history-item'));

if (historyDateSlider) {
    const options = {
        modules          : [Navigation],
        init             : false,
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 'auto',
        slidesOffsetAfter: 0,
        navigation       : {
            nextEl: '.j-history-next',
            prevEl: '.j-history-prev'
        },
        breakpoints: {
            1280: {
                // allowTouchMove: false,
                // spaceBetween  : 0
            }
        },
        // Необходимо для переключения активного слайда до последнего, иначе при достижении момента когда все слайды будут на экране - переключение активных слайдов отключается. Решение найдено здесь - https://github.com/nolimits4web/swiper/issues/3108#issuecomment-882444481
        on: {
            snapGridLengthChange() {
                if (this.snapGrid.length !== this.slidesGrid.length) {
                    this.snapGrid = this.slidesGrid.slice(0);
                }
            },

            slideChange() {
                textSlider.slideTo(this.activeIndex);
            }
        }
    };

    slider = new Swiper(historyDateSlider, options);
    slider.init();
}

if (historyTextSlider) {
    const textOptions = {
        modules          : [EffectFade],
        init             : false,
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 1,
        slidesOffsetAfter: 0,
        allowTouchMove   : false,
        effect           : 'fade',
        fadeEffect       : {
            crossFade: true
        }
    };

    textSlider = new Swiper(historyTextSlider, textOptions);
    textSlider.init();
}

allDates.forEach((item, index) => {
    item.addEventListener('click', () => {
        slider.slideTo(index);
        textSlider.slideTo(index);
    });
});
